import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MrService } from '../../mr.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-marketing-manager',
  templateUrl: './marketing-manager.component.html',
  styleUrls: ['./marketing-manager.component.css']
})
export class MarketingManagerComponent implements OnInit {
  mrform!:FormGroup

  constructor( private mrservise:MrService,private router:Router) { }

  ngOnInit(): void {
    this.mrform= new FormGroup({
      email : new FormControl(null,Validators.required),
      password : new FormControl(null,Validators.required),
    })
  }
   
  onSubmit(){
    let dt = this.mrform.value;
    console.log(dt);
    let payload = {
      email: dt.email,
      password: dt.password
    }
    this.mrservise.loginMr(payload).subscribe((res:any)=>{
      console.log("login successfully",res);
      localStorage.setItem('myData', JSON.stringify(res));
      console.log('Data stored in localStorage.');
      this.router.navigate(["/mr"]);
    })
  }
}
